import type { Action } from "../../actions/types";

export type AnimationPosition = "enter" | "leave";

export interface AnimationUnit {
  index: number;
  timeout: number;
  position: AnimationPosition;
}

export type StoreState = AnimationUnit[];

export const initialState = [];

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "REGISTER_ANIMATION":
      return [...state, action.data];

    case "RESET_ANIMATIONS":
      return [];

    default:
      return state;
  }
}
